import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={12.398}
    height={26.2}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 5471 11561"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:166.772}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974347713296">
        <path
          d="M3229 9825V4906h-82v4919zM2382 9791V4906h-82v4885zM4529 6257c-11 244-382 247-382 0s370-244 382 0c3 53 85 53 82 0-7-148-119-273-273-273-149 0-273 125-273 273 0 149 124 273 273 273 154 0 266-125 273-273 3-53-79-53-82 0z"
          className="fil0 stroke1"
          style={{
            strokeWidth: 166.772,
          }}
        />
        <path
          d="M4297 4917v1108c0 53 82 53 82 0V4917h-82zM3866 9825H1706c-60 0-120 5-158 122-51 158-23 445-23 622 0 58 23 107 51 107 694-1 1387 0 2080 0 98-1 196 0 294 0 27-1 51-49 51-107 0-247 43-686-121-740-65-22-93 183-27 204 79 26 45 420 45 536 17-35 34-70 52-106H1576c18 36 35 71 52 106 0-114-31-477 32-532 19-17 60 0 80 0h2126c67 0 67-212 0-212z"
          className="fil0 stroke1"
          style={{
            strokeWidth: 166.772,
          }}
        />
        <path
          d="M4771 11280H855c-59 0-132 44-149-143-11-120-4-301 60-329 18-9 40 0 58 0h3795c41 0 110-32 149 0 18 14 50 96 55 134 13 92 4 324-52 338-52 14-52 202 0 188 123-32 137-253 134-491-2-194-43-346-135-357-50-7-101 0-151 0H1340c-191 0-384-20-574 0-57 5-108 61-131 188-29 160-24 469 36 586 48 96 118 74 178 74h2022c623 0 1246 20 1869 0h31c53 0 53-188 0-188zM5346 4886H169c14 18 27 36 41 54l228-1608c120-853 241-1706 362-2560 27-193 55-387 82-582-14 11-27 21-41 32h3833c-14-11-28-21-41-32 75 537 151 1073 227 1609 121 853 242 1706 362 2559 28 194 55 388 83 582 7 54 89 31 82-23l-228-1608c-121-853-241-1706-362-2559-28-194-55-388-83-582-2-18-24-31-40-31H841c-17 0-38 13-41 31-76 536-152 1072-227 1608L210 4335c-27 194-55 388-82 582-4 27 11 54 41 54h5177c54 0 54-85 0-85z"
          className="fil0 stroke1"
          style={{
            strokeWidth: 166.772,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
